(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/gcs-restriction.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/gcs-restriction.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  isPnp
} = svs.legal_info.data;
const {
  isPoker
} = svs.legal_info.data.loginCheckOptions.model;
const {
  returnUrl,
  activeExclusions
} = svs.legal_info.data.loginCheckOptions.model;
const GcsRestriction = () => {
  const gcsContent = () => svs.accountservices.player_exclusions.template_literals.gcs_restriction(activeExclusions.gcsData);
  return React.createElement("section", {
    className: "f-content"
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "margin-top-1 margin-bottom-2 align-center"
  }, React.createElement(Icon, {
    color: isPnp ? 'fc-momang' : 'fc-sport-75',
    icon: "spelpaus",
    size: "1000"
  })), React.createElement("h1", {
    className: "align-center f-prominent padding-xs-h-1"
  }, "Just nu kan du inte spela eller s\xE4tta in pengar"), React.createElement("div", {
    className: "padding-xs-h-1 align-center"
  }, React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: gcsContent()
    }
  }), React.createElement("div", {
    className: "grid-row gutter-xs-1 margin-top-2"
  }, isPoker ? React.createElement("div", {
    className: "col-xs-6 col-xs-offset-3"
  }, React.createElement(Button, {
    block: true,
    href: returnUrl,
    inverted: true
  }, "Okej")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    className: "button ".concat(isPnp ? 'button-transparent button-inverted' : 'button-transparent', " button-block"),
    href: "/logga-ut",
    transparent: true
  }, "Logga ut")), React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    focus: isPnp,
    href: returnUrl,
    inverted: !isPnp
  }, "Okej")))))));
};
svs.legal_info.components.login_check.self_exclusion_info.GcsRestriction = GcsRestriction;

 })(window);